import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import { Form, Input, Icon, Button, Row, Spin, Modal } from 'antd';

import { api } from '../../../../services';

import './ChangePasswordForm.css';

@withRouter
@inject('translationsStore', 'authStore')
@observer
class ChangePasswordForm extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  handleSubmit = e => {
    e.preventDefault();
    const { authStore, history, translationsStore } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        console.log(authStore.user);
        api('changePassword', authStore.user, values.oldpassword, values.newpassword)
          .then(() => {
            this.setState({ loading: false });
            Modal.info({
              title: translationsStore.translate('changepassword.success'),
              onOk: () => {
                history.goBack();
              }
            });
          })
          .catch(error => {
            this.setState({ loading: false, message: error.message });
          });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { translationsStore } = this.props;
    return (
      <Spin spinning={this.state.loading}>
        <Form onSubmit={this.handleSubmit} className="ChangePasswordForm">
          <Form.Item>
            {getFieldDecorator('oldpassword', {
              rules: [{ required: true, message: translationsStore.translate('changepassword.message.oldpassword') }]
            })(
              <Input
                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                placeholder={translationsStore.translate('changepassword.placeholder.oldpassword')}
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('newpassword', {
              rules: [{ required: true, message: translationsStore.translate('changepassword.message.newpassword') }]
            })(
              <Input
                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                placeholder={translationsStore.translate('changepassword.placeholder.newpassword')}
              />
            )}
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" className="ChangePasswordFormButton">
              <span>{translationsStore.translate('changepassword.submit')}</span>
            </Button>
            <Row style={{ fontSize: '0.7rem', color: 'red' }}>{this.state.message}</Row>
          </Form.Item>
        </Form>
      </Spin>
    );
  }
}
export default Form.create()(ChangePasswordForm);



// WEBPACK FOOTER //
// ./src/components/App/ChangePassword/ChangePasswordForm/ChangePasswordForm.js